module.exports = __webpack_public_path__ + "static/media/WP_logo_large.8cb5c625.gif";